// extracted by mini-css-extract-plugin
export default {"upload":"style_upload__aSxPH","uploadPhoto":"style_uploadPhoto__6+u-Z"};